import moment from 'moment';
import _ from 'lodash';
import { calculatePercentage } from 'common/utils/utils';

export const FILTERS = {
  LAST_ISSUE_STATE: 'last_issue_state',
  ISSUE_STATE: 'issue_state'
};

export const ISSUE_STATES = {
  DONE: 'done',
  IN_PROGRESS: 'in-progress',
  CREATED: 'created'
};

export const getApiAdditionalFilters = () => {
  return {
    [FILTERS.ISSUE_STATE]: ISSUE_STATES.IN_PROGRESS
  };
};

const getFormattedIterationDates = iteration =>
  `${moment(iteration.start).format('MMM DD')}-${moment(iteration.end).format(
    'MMM DD'
  )}`;

export const getFormattedIssueTypeStats = (issueTypeStats, iteration) =>
  issueTypeStats.map(stat => {
    const days = Math.round(stat.total_duration / (60 * 24));
    return {
      issue_type: stat.issue_type,
      num_of_issue: stat.num_of_issues,
      percents: calculatePercentage(
        stat.total_duration,
        iteration.stats.total_duration,
        false
      ),
      totalInUnits: {
        value: days,
        label: 'Days',
        type: 'd',
        roundedInMinutes: days * 60 * 24
      },
      total: stat.total_duration
    };
  });

export const convertMinutesToTotalDisplay = total => {
  return `${_.get(total, 'value', '-')} ${_.get(total, 'label', '')}`;
};

export const getTableBasicConfig = (
  totalDurationPerIssueType,
  chartBarsDef
) => {
  return [{ name: 'Sprint', dataPoint: 'name' }, ...chartBarsDef].map(
    ({ name, dataPoint, color }) => ({
      name: name.toUpperCase(),
      dataPoint: dataPoint || name,
      color
    })
  );
};

export const getAllIterationDurationPerIssueType = iterations => {
  const allIterationDurationPerIssueType = _(iterations)
    .flatMap(iteration => iteration.stats.issue_type_stats)
    .groupBy('issue_type')
    .map((objs, key) => ({
      issue_type: key,
      total: _.sumBy(objs, 'total')
    }))
    .keyBy('issue_type')
    .value();

  allIterationDurationPerIssueType.total = _.sumBy(
    Object.values(allIterationDurationPerIssueType),
    issue => issue.total
  );

  return allIterationDurationPerIssueType;
};

export const formatBaseData = rawData => {
  return rawData.map(iteration => {
    const start = iteration.start_date;
    const end = iteration.completed_at
      ? iteration.completed_at
      : iteration.end_date;
    return {
      ...iteration,
      iterationName: iteration.name,
      name: `${iteration.name} (${getFormattedIterationDates({ start, end })})`,
      iterationDates: `${getFormattedIterationDates({ start, end })}`,
      start,
      end
    };
  });
};
